import { addDays, addMonths, addWeeks, differenceInCalendarDays, format, parseISO } from 'date-fns';
import { Cadence } from '../types/withdraw';

// Fixed demo "today" so sample data (overdue, due dates) stays consistent.
export const TODAY = new Date(2026, 9, 14);

export function toISO(date: Date): string {
  return format(date, 'yyyy-MM-dd');
}

export function todayISO(): string {
  return toISO(TODAY);
}

export function addDaysISO(days: number): string {
  return toISO(addDays(TODAY, days));
}

export function formatDate(iso: string, pattern = 'MMM d, yyyy'): string {
  if (!iso) return '—';
  return format(parseISO(iso), pattern);
}

export function firstContactDate(cadence: Cadence): string {
  if (cadence === 'weekly') return toISO(addWeeks(TODAY, 1));
  if (cadence === 'biweekly') return toISO(addWeeks(TODAY, 2));
  return toISO(addMonths(TODAY, 1));
}

export function daysUntil(iso: string): number {
  return differenceInCalendarDays(parseISO(iso), TODAY);
}
